"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CustomFieldFilter", {
    enumerable: true,
    get: function() {
        return CustomFieldFilter;
    }
});
const _zod = require("zod");
const _fields = require("../defs/fields");
const CustomFieldFilter = _zod.z.object({
    vis: _zod.z.array(_fields.CustomFieldUserClass).optional(),
    edit: _zod.z.array(_fields.CustomFieldUserClass).optional(),
    type: _zod.z.array(_fields.CustomFieldTypes).optional(),
    tags: _zod.z.array(_zod.z.string()).optional()
});
